// Temperature-specific conflict resolver (registered with the generic Needs-Attention
// architecture). Statutory rule: NEVER blanket last-write-wins, NEVER silently discard.
//   • server duplicate  → the idempotent backend already holds the record; treat the
//                          queue entry as resolved (safe to remove — data is NOT lost).
//   • permission/site revoked → keep as Needs attention (owner/manager must act).
//   • config changed    → preserve the recorded evidence; do not overwrite history.
import { OfflineGateway } from "./gateway";

export const TEMPERATURE_ENTITY = "temperature";

// classification is pure + unit-testable.
export function classifyTemperatureConflict(item) {
  const status = item?.last_safe_error?.status ?? null;
  if (status === 409 || item?.conflict?.duplicate) return "server_duplicate";
  if (status === 403) return "permission_revoked";
  if (status === 404) return "site_invalid";
  if (status === 409) return "config_changed";
  return "needs_manual_review";
}

export function registerTemperatureResolver(gateway = OfflineGateway) {
  gateway.registerResolver(TEMPERATURE_ENTITY, async (item, ctx) => {
    const kind = classifyTemperatureConflict(item);
    if (kind === "server_duplicate") {
      // Idempotent server already recorded it — removing the local queue entry is safe and
      // does NOT lose a statutory record (it exists server-side under the same operation_id).
      await ctx.outbox.remove(ctx.userKey, item.operation_id);
      return { resolved: true, kind };
    }
    // All other statutory cases: DO NOT discard, DO NOT overwrite. Leave visibly unresolved
    // for owner/manager action. Return guidance only.
    return { resolved: false, kind };
  });
}
